import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
import radio from '@/lib/radio.js'
import options from '@/lib/options.js'
import getProductJson from '@/lib/getProductJson.js'

import { formatMoney } from '@/lib/currency.js'

export default component((node, ctx) => {
  const opts = options(node)

  // cache
  getProductJson()

  opts.onUpdate(state => {
    getProductJson().then(json => {

      const variant = json.variants.filter(v => v.id == state.id)[0]

      slater.qs('[data-price]').innerHTML = formatMoney(variant.price)
      slater.qs('[data-compare-price]').innerHTML = formatMoney(variant.compare_at_price)

      ctx.emit('variantselected', variant);

    })
  })
})
